// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3hLlW","col":"styles_col__efilT"};